import { render, staticRenderFns } from "./template4.vue?vue&type=template&id=2476edea&scoped=true"
import script from "./template4.vue?vue&type=script&lang=js"
export * from "./template4.vue?vue&type=script&lang=js"
import style0 from "./template4.vue?vue&type=style&index=0&id=2476edea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476edea",
  null
  
)

export default component.exports